import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../assets/images/logo.svg";
import Spinner from "../components/Spinner";
import { UserContext } from "../contexts/user.context";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { sendResetPasswordEmail } = useContext(UserContext);
  const [showLoader, setShowLoader] = useState(false);
  const [email, setEmail] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    console.log(email);

    try {
      setShowLoader(true);
      await sendResetPasswordEmail(email);
      setShowLoader(false);
      toast.success(`An email has been sent to ${email}.`);
    } catch (error) {
      console.log(error);
      setShowLoader(false);
      toast.error(error?.error ?? "Something went wrong with registration.");
    }
  };
  if (showLoader) {
    return <Spinner />;
  }
  return (
    <div>
      <div className="flex flex-col items-center min-h-screen pt-6 sm:justify-center sm:pt-0 bg-gray-50">
        <div className="flex ml-4 lg:ml-0">
          <button
            onClick={() => {
              navigate("/");
            }}
          >
            <span className="sr-only">Family Tree</span>
            <img className="w-auto h-16" src={logo} alt="logo" />
          </button>
        </div>

        <div className="w-full px-6 py-4 mt-6 overflow-hidden bg-white shadow-md sm:max-w-md sm:rounded-lg">
          <form onSubmit={onSubmit}>
            <div className="mt-4">
              <div className="flex flex-col items-start">
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onInput={(e) => {
                    setEmail(e.target.value);
                  }}
                  required
                  placeholder="Email"
                  className="block w-full p-3 mb-4 border rounded border-grey-light"
                />
              </div>
            </div>
            <div className="flex justify-end mt-4">
              <button
                className="text-sm text-left text-indigo-600 underline hover:text-indigo-900"
                onClick={() => {
                  navigate("/sign-up");
                }}
              >
                Don't have an account?
              </button>

              <button
                type="submit"
                className="py-3 my-1 ml-4 text-center text-white bg-indigo-600 rounded px-7 hover:bg-indigo-900 focus:outline-none"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
